<div class="modal-header">
  <h4 class="modal-title h5" translate>Trigger configuration</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="triggerConfigurationForm">
  <div class="modal-body">
    <div class="row">
      <!-- NAME -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="name" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
            class="form-control" formControlName="name"
            id="name" name="name" type="text">
            @if (submitted && f.name.errors) {
              <div class="invalid-feedback">
                @if (f.name.errors.required) {
                  <span translate>Trigger configuration name required</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- ACTION TYPE -->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="triggerType" translate>Configuration type</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <ng-select (change)="onTriggerTypeChange($event)" [items]="triggerTypes"
              [ngClass]="{ 'is-invalid': submitted && f.triggerType.errors }"
              bindLabel="name" bindValue="id" formControlName="triggerType" id="triggerType">
            </ng-select>
            <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.triggerType.errors }"

              class="form-control"
              id="selectedTriggerType" type="text">
              @if (submitted && f.triggerType.errors) {
                <div class="invalid-feedback">
                  @if (f.triggerType.errors.required) {
                    <span translate>Trigger configuration type required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>


        <!--TRIGGER ACTIONS-->
        <table class="table vertical-align-middle mb-0">
          <thead>
            <tr>
              <th translate>Trigger action</th>
              <th translate>Type</th>
              @if (showResolveEmailField(machine.triggerExecutionInDataflow, selectedTriggerType)) {
                <th
                  translate>Resolve e-mail
                </th>
              }
              <th translate>Active</th>
              <th class="text-right" translate>Action</th>
            </tr>
          </thead>
          <tbody>
            @for (tq of triggerConfiguration.triggerQueries; track tq) {
              <tr>
                <td>
                  <span [ngClass]="getStatusCssClass(tq.initQueryExecuted)" class="status mr-1"></span>
                  <b [innerText]="tq.name"></b>
                </td>
                <td [innerText]="tq.triggerActionType"></td>
                @if (showResolveEmailField(machine.triggerExecutionInDataflow, selectedTriggerType)) {
                  <td>
                    <div class="form-group">
                      @if (showResolveCheckbox(tq)) {
                        <input (change)="onResolveEmailCheckBoxChange(tq)"
                          [(ngModel)]="tq.isResolveEvent" [checked]="tq.isResolveEvent" type="checkbox">
                      }
                    </div>
                  </td>
                }
                <td>
                  <span [ngClass]="getStatusCssClass(!tq.bannedInactive)"
                  class="status"></span>
                </td>
                <td class="text-right">
                  <button (click)="onRemoveTriggerQuery(tq)"
                    [disabled]="triggerActionRemoveButtonDisabled(tq.triggerActionType)"
                    class="btn btn-sm btn-outline-danger"
                    title="{{'Delete trigger action' | translate}}"
                    type="button"><span
                  class="fa-solid fa-trash"></span></button>
                </td>
              </tr>
            }
          </tbody>
        </table>

        <!-- Add trigger action -->
        <div class="form-group py-2">
          @if (isLoadingTriggerQueries) {
            <span class="fa-solid fa-spinner fa-spin"></span>
          }
          @if (triggerQueriesList.length > 0) {
            <ng-select (change)="onTriggerActionSelected($event)"
              [clearable]="false"
              [items]="triggerQueriesList"
              bindLabel="name" bindValue="id" formControlName="triggerAction" id="triggerAction"
              name="triggerAction" placeholder="Select trigger action">
            </ng-select>
          }
        </div>

        <hr>

          @if (showTimeBasedComponent()) {
            <scitis-admin-time-based
              (formIsValid)="onTimeBasedFormIsValid($event)"
              (updatedTriggerConfiguration)="onUpdatedTimeBased($event)"
              [cloudPlugs]="cloudPlugs"
              [isAdminOrHigher]="isAdminOrHigher"
              [isLoadingCloudPlugs]="isLoadingCloudPlugs"
              [selectedTriggerType]="selectedTriggerType"
              [submitted]="submitted"
              [triggerConfiguration]="triggerConfiguration">
            </scitis-admin-time-based>
          }

          @if (showValueBasedComponent()) {
            <scitis-admin-value-based
              (formIsValid)="onValueBasedFormIsValid($event)"
              (loadSignalsForCloudPlug)="onLoadSignalsForCloudPlug($event)"
              (updatedTriggerConfiguration)="onUpdatedValueBased($event)"
              [cloudPlugs]="cloudPlugs"
              [isAdminOrHigher]="isAdminOrHigher"
              [isLoadingCloudPlugs]="isLoadingCloudPlugs"
              [selectedTriggerType]="selectedTriggerType" [signals]="signals"
              [submitted]="submitted"
              [triggerConfiguration]="triggerConfiguration"
              [triggerExecutionInDataflow]="machine.triggerExecutionInDataflow ? machine.triggerExecutionInDataflow : false">
            </scitis-admin-value-based>
          }

          @if (showOpcOfflineComponent()) {
            <scitis-admin-opc-offline
              (formIsValid)="onOpcOfflineFormIsValid($event)"
              (updatedTriggerConfiguration)="onUpdatedOpcOffline($event)"
              [cloudPlugs]="cloudPlugs"
              [isAdminOrHigher]="isAdminOrHigher"
              [isLoadingCloudPlugs]="isLoadingCloudPlugs"
              [submitted]="submitted"
              [triggerConfiguration]="triggerConfiguration">
            </scitis-admin-opc-offline>
          }

          @if (showOpcNoDataComponent()) {
            <scitis-admin-opc-no-data
              (formIsValid)="onOpcNoDataFormIsValid($event)"
              (updatedTriggerConfiguration)="onUpdatedOpcNoData($event)"
              [cloudPlugs]="cloudPlugs"
              [isAdminOrHigher]="isAdminOrHigher"
              [isLoadingCloudPlugs]="isLoadingCloudPlugs"
              [submitted]="submitted"
              [triggerConfiguration]="triggerConfiguration">
            </scitis-admin-opc-no-data>
          }
        </div>

        <scitis-modal-footer
          (cancelButtonPressed)="onCancel()"
          (okButtonPressed)="onSave()"
          [cancelButtonText]="'Cancel'|translate"
          [disableOkButton]="isDisabledSaveBtn"
          [okButtonText]="'Save'|translate"
          [showRequiredFieldsIndicator]="true">
        </scitis-modal-footer>

      </form>
